export default "__VITE_ASSET__c793882c__"